export default __webpack_public_path__ + "static/media/ITmobile.6fbeae8a.png";